export const normalizeAvailabilityRanges = value => {
  if (!Array.isArray(value)) return [];
  return value
    .map(item => {
      if (!item) return null;
      const rawStart =
        typeof item.start === 'string'
          ? item.start
          : typeof item.from === 'string'
          ? item.from
          : typeof item.begin === 'string'
          ? item.begin
          : '';
      const rawEnd =
        typeof item.end === 'string'
          ? item.end
          : typeof item.to === 'string'
          ? item.to
          : typeof item.hasta === 'string'
          ? item.hasta
          : rawStart;
      const start = String(rawStart || '').trim();
      const end = String(rawEnd || '').trim();
      if (!start) return null;
      if (end && end < start) {
        return { start: end, end: start };
      }
      return { start, end: end || start };
    })
    .filter(Boolean);
};

export const parseAvailabilityRanges = value => {
  if (!value) return [];
  if (Array.isArray(value)) {
    return normalizeAvailabilityRanges(value);
  }
  if (typeof value === 'string') {
    try {
      const parsed = JSON.parse(value);
      return normalizeAvailabilityRanges(Array.isArray(parsed) ? parsed : []);
    } catch {
      return [];
    }
  }
  return [];
};
